// The words of the kit's SettingsEditor footer and its discard question (SettingsEditor.tsx).

export const editorCopy = {
  cancel: 'Cancel',
  save: 'Save',
  unsaved: 'Unsaved changes',
  discard: 'Discard',
  keepEditing: 'Keep editing',
  discardTitle: (name: string) => `Discard changes to ${name}?`,
  discardLine: (name: string) => `Your changes to the ${name.toLowerCase()} are not saved.`,
} as const;
